import { render, staticRenderFns } from "./ButtonPlus.vue?vue&type=template&id=74d21ef4"
import script from "./ButtonPlus.vue?vue&type=script&lang=js"
export * from "./ButtonPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports